// extracted by mini-css-extract-plugin
export default {"resetPassMain":"resetPassword_resetPassMain__RLlPF","resetPasswordForm":"resetPassword_resetPasswordForm__QVppz"};